import { CheckoutCgvPrivacy } from "./CheckoutCgvPrivacy";

export default CheckoutCgvPrivacy;
